let QQLiveConfig = require("activity/QQLive/QQLiveConfig")

let QQLivePanel = xClass("QQLivePanel", BasePanel, () => { 
        return cc.CSLoader.createNode("cocos/qqlive_panel_panel.csb") 
    })
/**
 * 预加载资源
 */
QQLivePanel.preload = function () {
    let platform = 2
    if (window.mqq){
        platform = window.OPEN_DATA.platform;//2-IOS，1-安卓
    }
    let resCategroy = QQLiveConfig.ios
    if (platform == 1){
        resCategroy = QQLiveConfig.android
    }
    return preloadWithLoadingPromise(resCategroy.resList, true);
}

QQLivePanel.prototype.ctor =  function (onCloseCallback){
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.onCloseCallback = onCloseCallback;
    self.initUI();
}

QQLivePanel.prototype.initUI = function() {
    let self = this

    self.ios = true
    if (window.mqq && window.OPEN_DATA.platform == 1){
        self.ios = false
    }
    self.setScale(Math.min(cc.winSize.height / GamePlayConfig_Design_Height, 1))

    self.quesBtn = self.getChildByName("btn_orange")
    quickBuildUIBUtton(self.quesBtn, handler(self, self.testLink))

    self.closeBtn = self.getChildByName("off_btn_light")
    quickBuildUIBUtton(self.closeBtn, () => {
        self.onClose()
    })
}

QQLivePanel.prototype.testLink = function() {
    let self = this
    if (window.mqq){
        let targetUrl
        if (self.ios){
            targetUrl = "https://iwan.qq.com/fun/mindex?ADTAG=txsp.wd.xyx&hidetitlebar=1&autoplay=1"
        }else{
            targetUrl = "https://iwan.qq.com/fun/mindex?ADTAG=txsp.wd.xyx&hidetitlebar=1&autoplay=1"
        }
        mqq.invoke("ui", "openUrl",{
            url     : targetUrl,
            target  : 2,
            style   : 1
        });
    }
}

QQLivePanel.prototype.onCleanup = function () {
    let self = this
    //TODO:repeat code
    let resCategroy = QQLiveConfig.ios
    if (!self.ios){
        resCategroy = QQLiveConfig.android
    }
    ResManager.release(resCategroy.resList)
}

module.exports = QQLivePanel;